import { FC } from 'react';
import { Form, Input } from 'antd';

import classes from './index.module.css';

interface TextFieldInputInterface {
	className?: string;
	name: string;
	label: string;
	rules?: any;
	placeholder?: string;
	onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	maxLength?: number;
}

const TextField: FC<TextFieldInputInterface> = ({
	name,
	label,
	rules,
	placeholder,
	className,
	onKeyPress,
	disabled,
	maxLength,
}) => {
	return (
		<Form.Item
			name={name}
			label={label}
			rules={rules}
			className={`${classes['text-field-box']} ${className}`}
		>
			<Input
				placeholder={placeholder}
				className={classes['text-field-input']}
				onKeyPress={onKeyPress}
				disabled={disabled}
				maxLength={maxLength}
			/>
		</Form.Item>
	);
};

export default TextField;
